<it-card>
	<h2 class="it-card-title it-card-title-icon h5">
		{{ dossier.title }}
		<div class="it-card-title-icon-wrapper">
			<it-icon name="folder"></it-icon>
		</div>
	</h2>
	<div class="it-card-body">
		<p class="it-card-text">
			{{ dossierType?.label?.[("iterlex.currentLanguage" | translate)] }}
			({{ "iterlex.dossier-state-" + dossier.state | translate }})<br />{{
				"iterlex.number" | translate
			}}
			{{ dossier.number }}, {{ dossier.date | date: "d/M/yyyy" }}
		</p>
	</div>
	<div class="it-card-footer">
		@if (dossier.metadata.modificationsDestinations) {
			<p>
				{{ "iterlex.modifications-destination" | translate }}:
				{{ dossier.metadata.modificationsDestinations.join(", ") }}
			</p>
		}
		@if (!importDossier.observed) {
			<a
				class="read-more"
				routerLink="/dossier"
				[queryParams]="{ uri: dossier.workUri }"
				[attr.aria-label]="
					('iterlex.go-to-dossier' | translate) + ' ' + dossier.title
				"
			>
				<span class="text">{{
					"iterlex.go-to-dossier" | translate
				}}</span>
				<it-icon name="arrow-right"></it-icon>
			</a>
		} @else {
			<button
				type="button"
				itButton="outline-primary"
				[progress]="progressImport"
				[disabled]="progressDelete || progressImport"
				size="xs"
				(click)="importDossier.emit(dossier)"
			>
				{{ "iterlex.import" | translate }}
			</button>
		}
		@if (deleteDossier.observed) {
			<button
				type="button"
				itButton="outline-danger"
				[progress]="progressDelete"
				[disabled]="progressDelete || progressImport"
				size="xs"
				(click)="deleteDossier.emit(dossier)"
			>
				{{ "it.core.remove" | translate }}
			</button>
		}
	</div>
</it-card>
